import PropTypes from 'prop-types';

function GovWarningIcon({ width }) {
    return (
        <svg className="inline-block" width={width} viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3450_35469)">
                <path
                    d="M1.48508 12.1749H13.4783C13.6333 12.1749 13.7765 12.0915 13.854 11.956C13.9315 11.8207 13.9315 11.6538 13.854 11.5184L7.85737 1.03915C7.77987 0.903731 7.63668 0.820312 7.48172 0.820312C7.32673 0.820312 7.18354 0.903731 7.10606 1.03915L1.1094 11.5184C1.03189 11.6538 1.03189 11.8207 1.1094 11.956C1.18688 12.0914 1.33009 12.1749 1.48508 12.1749Z"
                    fill="black"
                />
                <path d="M7.48176 2.13843L12.7228 11.2972H2.24072L7.48176 2.13843Z" fill="#FFFF00" />
                <path
                    d="M7.48133 10.5339C7.81296 10.5339 8.0818 10.2627 8.0818 9.9281C8.0818 9.59351 7.81296 9.32227 7.48133 9.32227C7.1497 9.32227 6.88086 9.59351 6.88086 9.9281C6.88086 10.2627 7.1497 10.5339 7.48133 10.5339Z"
                    fill="black"
                />
                <path
                    d="M7.84635 8.6407L8.2771 4.67631C8.31222 4.35313 8.15288 4.03996 7.87208 3.8804C7.59133 3.72084 7.2433 3.74562 6.98756 3.94343C6.73181 4.14124 6.61766 4.4739 6.69746 4.78888L7.14522 8.72322C7.15962 8.84973 7.23991 8.95892 7.35579 9.00945C7.47168 9.06001 7.60552 9.04425 7.70677 8.96813C7.80797 8.89206 7.86122 8.76716 7.84635 8.6407Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_3450_35469">
                    <rect width="13.5" height="12" fill="white" transform="translate(0.75 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default GovWarningIcon;

GovWarningIcon.propTypes = {
    width: PropTypes.number,
};

GovWarningIcon.defaultProps = {
    width: 15,
};
